import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent implements OnInit {

  @Input() modalId: string;
  @Input() modalOpenButtonId: string;
  @Input() modalCloseButtonId: string;
  @Input() modalHeader: string;
  @Input() content: string;
  @Input() submitButtonClass: string = 'btn btn-primary btn-80';
  @Input() cancelButtonClass: string = 'btn btn-light btn-80';

  @Output() saveEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancelEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  onConfirm() {
    this.saveEmitter.emit();
  }

  onCancel() {
    this.cancelEmitter.emit();
  }

}
